<div id='footer-container' class="full-width padding theme-border-top text-center">

    <div class="links-container text-center padding">
        <a *ngFor='let link of legalLinks' [href]='link.url'
            [target]="link.name === 'Site Map' ? '' : '_blank'">{{ link.name }}</a>
    </div>

    <!-- <div class="social-links-container text-center">
        <a [href]='socialLinks.facebook' target="_blank">
            <fa name="fab fa-facebook"></fa>
        </a>
        <a [href]='socialLinks.twitter' target="_blank">
            <fa name="fab fa-twitter"></fa>
        </a>
        <a [href]='socialLinks.linkedin' target="_blank">
            <fa name="fab fa-linkedin"></fa>
        </a>
    </div> -->

    <h5 class="margin-auto pad-8">
        Copyright © 2020 uTrade. All rights reserved.
    </h5>
    <h5 class="footer-about margin-auto padding-bottom">
        uTrade is a FinTech company providing
        multi-asset full suite trading platform, low latency algos engine,
        risk management and DMA FIX gateway.
        
        Our products are widely used by global financial institutions
        including Brokers, Algo Firms, Banks,
        Stock Exchanges, Fund managers and
        their end customers.
    </h5>
</div>